import { useEffect, useState } from 'react';
import { useCustomerChatbotContext } from './use-customer-chatbot-context';

export function useInitialMessage() {
  const [initialMessage, setInitialMessage] = useState<string>('Hola! En qué puedo ayudarte?');
  const { customerChatbot } = useCustomerChatbotContext();

  useEffect(() => {
    window.addEventListener('popstate', changeInitialMessage);
    function changeInitialMessage() {
      if (!customerChatbot?.initialMessages) return;
      const { initialMessages } = customerChatbot;
      // Try to find the initial message for the current URL
      let chatbotInitialMessage = '';
      for (const { message, urlMatcher } of initialMessages.additionalMessages || []) {
        for (const pattern of urlMatcher) {
          const regex = new RegExp(pattern);
          if (regex.test(window.endion_debug?.simulatedOrigin || window.location.href)) {
            chatbotInitialMessage = message;
          }
        }
      }

      // If a chain specific initial message exists for this URL
      if (chatbotInitialMessage) {
        return setInitialMessage(chatbotInitialMessage);
      }
      // Otherwise, set the default initial message
      setInitialMessage(initialMessages.defaultMessage);
    }
    changeInitialMessage();
    return () => {
      window.removeEventListener('popstate', changeInitialMessage);
    };
  }, [customerChatbot, customerChatbot?.initialMessages]);

  return { initialMessage };
}
